import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.less';
import SchoolLink from '../TinyComponents/SchoolLink';
import Map from '../Map';
// import { RouteContext } from '../../hoc/Route';

const CourseMap = ({ location, school, show, isStaticMap }) => {
  const { lat, lng, city, street, house_number: houseNumber, zip_code: zipCode } = location;

  // const { page } = React.useContext(RouteContext);

  return (
    <div id="map" className={styles.container}>
      <div className={styles.map}>
        <Map
          zoom={14}
          defaultZoom={10}
          center={{ lng: parseFloat(lng), lat: parseFloat(lat) }}
          defaultCenter={{ lng: parseFloat(lng), lat: parseFloat(lat) }}
          markers={[{ lng: parseFloat(lng), lat: parseFloat(lat) }]}
          gestureHandling="cooperative"
          isStaticMap={isStaticMap}
        />
      </div>

      <div className={styles.school}>
        <SchoolLink className={styles.schoolName} school={school} />
      </div>
      {show ? (
        <div className={styles.location}>
          <a
            rel="noopener noreferrer"
            target="_blank"
            href={`http://maps.google.com/maps?q=${houseNumber}+${street},${city},+${zipCode}`}
          >
            {`${city}, ${street} ${houseNumber}, ${zipCode}`}
          </a>
        </div>
      ) : null}
    </div>
  );
};

CourseMap.propTypes = {
  location: PropTypes.object.isRequired,
  school: PropTypes.object.isRequired,
  show: PropTypes.bool,
  isStaticMap: PropTypes.bool,
};

CourseMap.defaultProps = {
  show: true,
  isStaticMap: false
};

export default CourseMap;
